import { action, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../common/Api";

export class CommunityStore {
  loading = false;
  saving = false;
  id?: string;

  data: any = {};

  constructor() {
    makeAutoObservable(this, {});
  }

  @action onLoad(id) {
    this.id = id;
    this.refresh();
  }

  @action
  refresh() {
    this.loading = true;
    Api.community
      .community(this.id)
      .then((res) => {
        runInAction(() => {
          this.data = res.data.community;
        });
      })
      .finally(() => (this.loading = false));
  }
}

export const communityStore = new CommunityStore();
